import React from 'react';
import CursorTrail from './common/CursorTrail';
import { TECH_ICONS } from '../utils/constants';

/**
 * Main Layout Component
 * Wraps the application content with background effects and cursor trail.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render
 * @returns {JSX.Element} Main layout wrapper
 */
const Main = ({ children }) => {
  return (
    <div className="main-layout">
      {/* Animated Background */}
      <div className="animated-bg" aria-hidden="true">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>

      {/* Floating Tech Icons - aria-hidden as decorative */}
      <div className="floating-tech-icons" aria-hidden="true">
        {TECH_ICONS.map((icon) => (
          <div key={icon.id} className={`tech-icon ${icon.className}`}>
            <img src={icon.src} alt="" loading="lazy" />
          </div>
        ))}
      </div>

      <CursorTrail />

      {/* Main Content Render */}
      <div id="wrapper">
        {children}
      </div>
    </div>
  );
};

export default Main;
